var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (containerAttributes, fieldsetCounter, fileInputAttributes, globals, id, validationId) {
      pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["textarea"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.attributes) {
attributes.attributes = {}
}
if (attributes.id) {
id = attributes.id
}
if (!attributes.trim) {
attributes.trim = false
}
if (!attributes.rows) {
attributes.rows = 5
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv class=\"form-group\"\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"control-label\""+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
pug_html = pug_html + "\u003Ctextarea" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"rows": pug.escape(attributes.rows),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"ng-trim": pug.escape(attributes.trim),"name": pug.escape(id),"required": pug.escape(attributes.required),"disabled": pug.escape(attributes.disabled)},attributes.attributes]), true)) + "\u003E\u003C\u002Ftextarea\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};

































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};
pug_mixins["select"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.attributes) {
attributes.attributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "form-group"},attributes.groupAttributes]), true)) + "\u003E\u003Clabel" + (" class=\"control-label\""+pug.attr("for", attributes.key, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E\u003Cselect" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"name": pug.escape(id),"id": pug.escape(id),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"disabled": pug.escape(attributes.disabled),"required": pug.escape(attributes.required),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
if (attributes.titleMap) {
// iterate attributes.titleMap
;(function(){
  var $$obj = attributes.titleMap;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var option = $$obj[pug_index3];
if ('object' === typeof option) {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option.value, false, true)) + "\u003E" + (pug.escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
else {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = option) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var option = $$obj[pug_index3];
if ('object' === typeof option) {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option.value, false, true)) + "\u003E" + (pug.escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
else {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = option) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
    }
  }
}).call(this);

}
block && block();
pug_html = pug_html + "\u003C\u002Fselect\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_mixins["dropzone"] = pug_interp = function(model, single, id, tags, employeeId, cyData){
var block = (this && this.block), attributes = (this && this.attributes) || {};
containerAttributes = {}
fileInputAttributes = {}
if (single) {
containerAttributes = { 'made-dropzone-single' : 'true' }
fileInputAttributes = { 'made-file-single' : 'true' }
}
else {
fileInputAttributes = { multiple : 'multiple' }
}
if (!id) {
id = 'uploader'
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "dropzone-container","made-dropzone": pug.escape(model)},containerAttributes,attributes]), true)) + "\u003E\u003Cdiv class=\"dropzone-inner-container\"\u003E";
if (employeeId) {
pug_html = pug_html + "\u003Cfile-chooser" + (pug.attr("files", model, true, true)+pug.attr("filter-tags", tags, true, true)+pug.attr("employee-id", employeeId, true, true)) + "\u003E\u003C\u002Ffile-chooser\u003E\u003Cdiv class=\"divider\"\u003Eoder\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + ("\u003Cdiv class=\"drag-and-drop-label\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsvg\u002Ficon-download.svg\"\u003E" + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)));
if (single) {
pug_html = pug_html + "\u003Cspan\u003EDatei hierherziehen\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003EDateien hierherziehen\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"divider\"\u003Eoder\u003C\u002Fdiv\u003E\u003Cdiv class=\"file-input\"\u003E\u003Cinput" + (pug.attrs(pug.merge([{"id": pug.escape(id),"type": "file","made-file-input": pug.escape(model),"style": "visibility:hidden","data-cy": pug.escape(cyData)},fileInputAttributes]), true)) + "\u003E";
if (single) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("for", id, true, true)) + "\u003E\u003Cspan class=\"button\"\u003EDatei auswählen\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
else {
pug_html = pug_html + "\u003Clabel" + (pug.attr("for", id, true, true)) + "\u003E\u003Cspan class=\"button\"\u003EDateien auswählen\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"files\"\u003E";
if (block) {
block && block();
}
else
if (single) {
pug_html = pug_html + "\u003Cspan" + (pug.attr("ng-if", model +' && !'+ model +'._id', true, true)) + "\u003E" + (pug.escape(null == (pug_interp = ' {{ '+ model +'.name }} ({{ '+ model +'.size | filesize }})') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Ca" + (pug.attr("ng-if", model +' && !'+ model +'._id', true, true)+pug.attr("ng-click", model + '=undefined', true, true)) + "\u003E\u003Ci class=\"font-icon icon-close right\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003Ca" + (pug.attr("ng-if", model +'._id', true, true)+pug.attr("ng-href", '/gridfs?id={{'+ model +'._id}}', true, true)+" target=\"_blank\" rel=\"noreferrer\"") + "\u003E" + (pug.escape(null == (pug_interp = ' {{ '+ model +'.name }} ({{ '+ model +'.size | filesize }})') ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv" + (" class=\"files\""+pug.attr("ng-repeat", '(index, file) in ' + model, true, true)) + "\u003E\u003Cspan ng-if=\"!file._id\"\u003E{{ file.name }} ({{ file.size | filesize }})\u003C\u002Fspan\u003E\u003Ca" + (pug.attr("ng-click", model + '.splice(index, 1)', true, true)) + "\u003E\u003Ci class=\"font-icon icon-close right\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003Ca ng-if=\"file._id\" ng-href=\"\u002Fgridfs?id={{ file._id }}\" target=\"_blank\" rel=\"noreferrer\"\u003E{{ file.filename }} ({{ file.meta.created *1000 | date }}, {{ file.length | filesize }})\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"cockpit-panel__title\"\u003ESupport kontaktieren\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit_arbeitnmv-wrapper\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12 filter-input\"\u003E\u003Cdiv\u003E";
pug_mixins["select"].call({
attributes: {"key": "$ctrl.models.support.category","title": "Bitte wählen Sie eine Kategorie aus, damit wir Ihnen bestmöglichst helfen können","required": pug.escape(true),"attributes": {"ng-options":"support_category.display as support_category.display for support_category in $ctrl.support_categories"},"validationMessages": {"required":"Es wird eine Eingabe benötigt."}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.models.support.category &amp;&amp; $ctrl.models.support.category != &quot;Schaden PC-Leasing melden&quot;\"\u003E\u003Cdiv class=\"columns medium-12\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.models.support.subject","required": pug.escape(true),"title": "Thema","validationMessages": {"required":"Es wird eine Eingabe benötigt."},"placeholder": "Thema"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.models.support.category &amp;&amp; $ctrl.models.support.category != &quot;Schaden PC-Leasing melden&quot;\"\u003E\u003Cdiv class=\"columns medium-12\"\u003E";
pug_mixins["textarea"].call({
attributes: {"key": "$ctrl.models.support.message","required": pug.escape(true),"title": "Ihre Anfrage","validationMessages": {"required":"Es wird eine Eingabe benötigt."},"placeholder": "Ihre Anfrage"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.models.support.category &amp;&amp; $ctrl.models.support.category != &quot;Schaden PC-Leasing melden&quot; &amp;&amp; $ctrl.models.support.category != &quot;Ich wünsche eine Beratung&quot;\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Ch3\u003ESupportdokumente\u003C\u002Fh3\u003E";
pug_mixins["dropzone"]('$ctrl.models.attachments', false, 'support_request');
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E";
},
attributes: {"class": "form-padding","name": "$ctrl.forms.support_form"}
});
pug_html = pug_html + "\u003Cdiv class=\"row\" ng-if=\"$ctrl.models.support.category &amp;&amp; $ctrl.models.support.category != &quot;Schaden PC-Leasing melden&quot;\"\u003E\u003Cdiv class=\"column small-12 large-6\"\u003E\u003Cbutton class=\"button button-primary left\" ng-click=\"$ctrl.send()\" ng-disabled=\"$ctrl.forms.support_form.$invalid\" overlay=\"$ctrl.loading.sending\"\u003ESenden\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-12 large-6\"\u003E\u003Cbutton class=\"button button-primary right\" ng-click=\"$ctrl.close()\"\u003EAbbrechen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.models.support.category == &quot;Schaden PC-Leasing melden&quot;\"\u003E\u003Cdiv\u003EHier finden Sie die gültigen Versicherungsbedingungen.\u003C\u002Fdiv\u003E\u003Cdiv class=\"iframe-popup-trigger\"\u003E\u003Ca class=\"button button-primary\" magnific-popup=\"{type: &quot;iframe&quot;}\" ng-href=\"https:\u002F\u002Fportal.valuenet.de\u002Fassets\u002Ffiles\u002Fmlf_elektronikversicherung_merkblatt.pdf\"\u003EBedingungen\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.models.support.category == &quot;Schaden PC-Leasing melden&quot;\"\u003E\u003Cdiv\u003EBei der Meldung eines Schadens zum PC-Leasing finden Sie hier ein umfangreiches Schadensformular. Nur bei vollständiger Einreichung können wir schnellstmöglich mit der Bearbeitung fortfahren.\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.models.support.category == &quot;Schaden PC-Leasing melden&quot;\"\u003E\u003Cdiv class=\"consent-dialog-wrapper\" ng-if=\"!$ctrl.consentServiceAccepted\"\u003E\u003Cvn-consent-dialog [uc-service-name]=\"$ctrl.consentServiceName\" (uc-service-status)=\"$ctrl.handleStatus($event)\" class=\"asana-consent-dialog\"\u003E\u003C\u002Fvn-consent-dialog\u003E\u003C\u002Fdiv\u003E\u003Ciframe ng-if=\"$ctrl.consentServiceAccepted\" src=\"https:\u002F\u002Fform.asana.com\u002F?k=lBmtL7GmbTkPmCHH0XUB6w&amp;d=11919111970056&amp;embed=true\" style=\"width: 100%; height: 1500px\" allowfullscreen\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "containerAttributes" in locals_for_with ?
        locals_for_with.containerAttributes :
        typeof containerAttributes !== 'undefined' ? containerAttributes : undefined, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "fileInputAttributes" in locals_for_with ?
        locals_for_with.fileInputAttributes :
        typeof fileInputAttributes !== 'undefined' ? fileInputAttributes : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;